(ns ballot-scout-v2-frontend.dashboard.events
  (:require
   [ajax.edn :refer [edn-request-format edn-response-format]]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.dashboard.common :refer [dis-key]]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.exports.events :as e.exports]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [goog.net.jsloader :as jsloader]
   [re-frame.core :as rf]))

(defn- current-partner-jurisdiction-and-election?
  [db pslug jslug eslug]
  (let [{:keys [partner-slug jurisdiction-slug election-slug]}
        (get-in db [:current-route :path-params])]
    (and (= election-slug eslug)
         (= jurisdiction-slug jslug)
         (= partner-slug pslug))))

(rf/reg-event-fx
 ::fetch-ballots-by-status-and-jurisdiction
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])
         election-slug (get-in route [:path-params :election-slug])]
     {:db (assoc db :ballots-by-status :loading)
      ::events/ajax {:method :get
                     :uri (urls/ballots-by-status-and-jurisdiction jurisdiction-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-ballots-by-status-success route event-vec]
                     :on-failure [::fetch-ballots-by-status-failure route event-vec]}})))

(rf/reg-event-fx
 ::fetch-ballots-by-status-and-partner
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [partner-slug (get-in route [:path-params :partner-slug])
         election-slug (get-in route [:path-params :election-slug])]
     {:db (assoc db :ballots-by-status :loading)
      ::events/ajax {:method :get
                     :uri (urls/ballots-by-status-and-partner partner-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-ballots-by-status-success route event-vec]
                     :on-failure [::fetch-ballots-by-status-failure route event-vec]}})))

(rf/reg-event-fx
 ::fetch-ballots-by-status-success
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :ballots-by-status response)
          db)
    :dispatch [::request-helpers/clear-failed-request event-vec]}))

(rf/reg-event-fx
 ::fetch-ballots-by-status-failure
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :ballots-by-status :error)
          db)
    :dispatch [::request-helpers/request-failed event-vec response]}))

;; ballots by location -- for map view
(rf/reg-event-fx
 ::fetch-ballots-by-location-and-jurisdiction
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [election-slug (get-in route [:path-params :election-slug])
         jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])]
     {:db (assoc db :ballots-by-location :loading)
      ::events/ajax {:method :get
                     :uri (urls/ballots-by-location-and-jurisdiction jurisdiction-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-ballots-by-location-success route event-vec]
                     :on-failure [::fetch-ballots-by-location-failure route event-vec]}})))

(rf/reg-event-fx
 ::fetch-ballots-by-location-and-partner
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [election-slug (get-in route [:path-params :election-slug])
         partner-slug (get-in route [:path-params :partner-slug])]
     {:db (assoc db :ballots-by-location :loading)
      ::events/ajax {:method :get
                     :uri (urls/ballots-by-location-and-partner partner-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-ballots-by-location-success route event-vec]
                     :on-failure [::fetch-ballots-by-location-failure route event-vec]}})))

(rf/reg-event-fx
 ::fetch-ballots-by-location-success
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :ballots-by-location response)
          db)
    :dispatch [::request-helpers/clear-failed-request event-vec]}))

(rf/reg-event-fx
 ::fetch-ballots-by-location-failure
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :ballots-by-location :error)
          db)
    :dispatch [::request-helpers/request-failed event-vec response]}))

(rf/reg-cofx
 ::google-maps-loaded?
 (fn [cofx]
   (assoc cofx :google-maps-loaded? (or (not (exists? js/google))
                                        (not (exists? js/google.maps))))))

(rf/reg-fx
 ::load-google-maps-fx
 (fn [google-maps-url]
   (doto ^js (jsloader/safeLoad google-maps-url)
     (.addCallback (fn [_]
                     (rf/dispatch [::load-google-maps-success])))
     (.addErrback (fn [_]
                    (rf/dispatch [::load-google-maps-failure]))))))

(rf/reg-event-fx
 ::load-google-maps-api
 [(rf/inject-cofx ::google-maps-loaded?)]
 (fn [{:keys [google-maps-loaded?]} [_ google-maps-url]]
   (if google-maps-loaded?
     {::load-google-maps-fx google-maps-url}
     {})))

(rf/reg-event-db
 ::load-google-maps-success
 (fn [db _]
   (assoc db :maps-lib-loaded true)))

(rf/reg-event-db
 ::load-google-maps-failure
 (fn [db _]
   (assoc db :maps-lib-loaded false)))

(rf/reg-event-fx
 ::fetch-days-in-service-for-jurisdiction
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [election-slug (get-in route [:path-params :election-slug])
         jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])]
     {:db (assoc db :days-in-service-stats :loading)
      ::events/ajax {:method :get
                     :uri (urls/days-in-service-by-jurisdiction jurisdiction-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-days-in-service-success route event-vec]
                     :on-failure [::fetch-days-in-service-failure route event-vec]}})))

(rf/reg-event-fx
 ::fetch-days-in-service-for-partner
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [election-slug (get-in route [:path-params :election-slug])
         partner-slug (get-in route [:path-params :partner-slug])]
     {:db (assoc db :days-in-service-stats :loading)
      ::events/ajax {:method :get
                     :uri (urls/days-in-service-by-partner partner-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-days-in-service-success route event-vec]
                     :on-failure [::fetch-days-in-service-failure route event-vec]}})))

(rf/reg-event-fx
 ::create-dis-export-for-jurisdiction
 (fn [_ [_ jurisdiction-id election-id mimetype]]
   {:dispatch [::e.exports/create-export-for-jurisdiction
               dis-key
               (urls/days-in-service-export-for-jurisdiction jurisdiction-id election-id)
               jurisdiction-id
               election-id
               {}
               mimetype]}))

(rf/reg-event-fx
 ::create-dis-export-for-partner
 (fn [_ [_ partner-id election-id mimetype]]
   {:dispatch [::e.exports/create-export-for-partner
               dis-key
               (urls/days-in-service-export-for-partner partner-id election-id)
               partner-id
               election-id
               {}
               mimetype]}))

(rf/reg-event-fx
 ::clear-dis-export-state
 (fn [_ [_]]
   {:dispatch [::e.exports/clear-export-state dis-key]}))

(rf/reg-event-fx
 ::fetch-days-in-service-success
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :days-in-service-stats response)
          db)
    :dispatch [::request-helpers/clear-failed-request event-vec]}))

(rf/reg-event-fx
 ::fetch-days-in-service-failure
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :days-in-service-stats :error)
          db)
    :dispatch [::request-helpers/request-failed event-vec response]}))

(rf/reg-event-fx
 ::fetch-noty-stats-for-jurisdiction
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [election-slug (get-in route [:path-params :election-slug])
         jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])]
     {:db (assoc db :noty-stats :loading)
      ::events/ajax {:method :get
                     :uri (urls/noty-stats-by-jurisdiction jurisdiction-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-noty-stats-success route event-vec]
                     :on-failure [::fetch-noty-stats-failure route event-vec]}})))

(rf/reg-event-fx
 ::fetch-noty-stats-for-partner
 (fn [{:keys [db]} [_ route :as event-vec]]
   (let [election-slug (get-in route [:path-params :election-slug])
         partner-slug (get-in route [:path-params :partner-slug])]
     {:db (assoc db :noty-stats :loading)
      ::events/ajax {:method :get
                     :uri (urls/noty-stats-by-partner partner-slug election-slug)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::fetch-noty-stats-success route event-vec]
                     :on-failure [::fetch-noty-stats-failure route event-vec]}})))

(rf/reg-event-fx
 ::fetch-noty-stats-success
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :noty-stats response)
          db)
    :dispatch [::request-helpers/clear-failed-request event-vec]}))

(rf/reg-event-fx
 ::fetch-noty-stats-failure
 (fn [{:keys [db]} [_ {:keys [path-params] :as _route} event-vec response]]
   {:db (if (current-partner-jurisdiction-and-election?
             db
             (:partner-slug path-params)
             (:jurisdiction-slug path-params)
             (:election-slug path-params))
          (assoc db :noty-stats :error)
          db)
    :dispatch [::request-helpers/request-failed event-vec response]}))
